/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Dashboard } from '../models/Dashboard';

export class ListDashboardsResponse {
  /**
  * List of dashboards
  */
  'dashboards': Array<Dashboard>;
  /**
  * Token to retrieve the next page of results
  */
  'nextToken'?: string | null;
  /**
  * Total number of dashboards
  */
  'totalCount'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dashboards",
      "baseName": "dashboards",
      "type": "Array<Dashboard>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListDashboardsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

